// Libs
import { createSelector } from 'reselect'
import _keys from 'lodash/keys'

import operations$ from './operations'

export default createSelector(
  [
    operations$,
  ],
  (operations) => {
    const firstKey = _keys(operations)[0]

    if (firstKey) {
      return operations[firstKey]
    }

    return null
  }
)
